import { render, staticRenderFns } from "./bloodPressureStatisticList.vue?vue&type=template&id=0f1fb5e0"
import script from "./bloodPressureStatisticList.vue?vue&type=script&lang=js"
export * from "./bloodPressureStatisticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports